export const drawerWidth = 260;
export const drawerClosedWidth = 50;
export const addEditDrawerWidth = 350;

export const actionColumns = ['actions'];
export const pageSizes = [10, 20, 50];
export const filteringStateColumnExtensions = [
  { columnName: 'actions', filteringEnabled: false },
];

export const stockAvailability = { 'available': 'AVAILABLE', 'unavailable': 'UNAVAILABLE' };
export const transportOrderState = { 'moving': 'MOVING', 'done': 'DONE', 'stopped': 'STOPPED' };

//number of colums on the orders overview page => 12/12 => 1 colum , 6/12 => 2, 4/12 => 3 , 3/12 => 4, ...
export const xsValue = 12 // 1 colum

// factor = 1 => tolerance compared with 100% of the measurement
// factor = 2 => tolerance compared with 50% of the measurement
// factor = 5 => tolerance compared with 20% of the measurement, .....
export const orderArticleWeightToleranceFactor = 5
export const orderArticleLengthToleranceFactor = 5
export const orderArticleWidthToleranceFactor = 5
export const orderArticleThicknessToleranceFactor = 5

//Machine parameters
export const machineParameterNames = { 'vacuümpomp': 'Kaliber Vacuümpomp', 'opening': 'Opening', 'temperatuur': 'Temperatuur', 'luchtblazer': 'Luchtblazer', 'oventemperatuur': 'Oven temperatuur', 'coronaKw': 'Corona Kw', 'trekrollendruk': 'Trekrollen druk', 'output': 'Output', 'treksnelheid': 'Treksnelheid', 'pomptoerental': 'Pomptoerental', 'matrijstemperatuurzones': 'Matrijs temperatuurzones' }

//Machine Types
export const machine = 1;
export const carpentryMachine = 5;
export const recyclingMachine = 6;
export const machineScissor = 2;
export const machineScissorZone = 3;

//MachineIds
export const Line11 = 1;
export const Line12 = 2;
export const Line14 = 114;
export const Line15 = 115;
export const Line16 = 116;
export const Line17 = 117;
export const Line18 = 118;
export const UpperScissorLine11 = 3;
export const LowerScissorLine11 = 4;
export const UpperScissorLine12 = 5;
export const LowerScissorLine12 = 6;
export const UpperScissorLine14 = 119;
export const LowerScissorLine14 = 120;

export const UpperScissorLine15 = 133;
export const LowerScissorLine15 = 134;
export const UpperScissorLine16 = 147;
export const LowerScissorLine16 = 148;
export const UpperScissorLine17 = 161;
export const LowerScissorLine17 = 162;
export const UpperScissorLine18 = 175;
export const LowerScissorLine18 = 176;

export const Breaker1 = 190;

// Machine Codes
export const machineCodes = [{ id: 1, code: "11" }, { id: 2, code: "12" }, { id: 114, code: "14" }, { id: 115, code: "15" }, { id: 116, code: "16" }, { id: 117, code: "17" }, { id: 118, code: "118" }]

//Default login authentication error message
export const defaultAuthenticationErrorMessage = "The username and password do not match"

export const loginUserName = "demo"
export const loginPassWord = "demo"

//Material parameters
export const uomKg = "Kg";
export const uomPieces = "Stuks";
export const uomGr = "G";
export const uomM = "M";
export const uomMm = "MM";
export const carrierTypePallet = 2;
export const EnergieProductGroup = "ENERGIE";

//Product type
export const productTypePackaging = 'Packaging'
export const productTypeAdditive = 'Additive'
export const productTypeRawMaterial = 'RawMaterial'
export const productTypeTapeFoil = 'TapeFoil'
export const productTypeUnKnown = 'UnKnown'

//BOL namen
export const oprolsysteem = "OPROLSYSTEEM"
export const bedrukker = "BEDRUKKER"
export const bedrukker10 = "BEDRUKKER10"
export const bedrukker15 = "BEDRUKKER15"
export const coronabehandeling = "P1CORONABEHANDELING"
export const microperforatie = "P1MICROPERFORATIE"
export const rillijnen = "P1RILLIJNEN"
export const snijlijnen = "P1SNIJLIJNEN"
export const waving = "P1WAVING"

// DataTypes
export const bool = 1;
export const integer = 2;
export const decimal = 3;
export const string = 4;

// Machine reasons
export const UnKnown = 0;
export const EndOfOrder = 1;
export const Cleaning = 2;
export const Rupture = 3;

// Notification types
export const MachinePlannedStop = 1;
export const MachineUnPlannedStop = 2;
export const MachineStart = 3;
export const QualityOutOfSpec = 4;
export const ScissorScrap = 5;
export const ScissorProduction = 6;
export const UnKnownQualityCheckType = 7;

// Dimension quality checks
export const dimensionQualityChecks = { 'LENGTEL': 'Lengte L', 'LENGTER': 'Lengte R', 'BREEDTE': 'Breedte', 'DIKTE': 'Dikte', 'GEWICHT': 'Gewicht' }

// Quality checks
export const qualityChecks = { 'TIRAGE': 'Tirage', 'OUTPUT_EXTRUDEUR': 'Output Extrudeur', 'OUTPUT_EXTRUDER': 'Output Extruder'}

// QualitySample codes
export const LengteL = 'BT01';
export const LengteR = 'BT02';
export const Breedte = 'BT03';
export const Dikte = 'BT04';
export const Gewicht = 'BT05';

// SystemParamaters
export const systemParameters = { 'Silos': 1, 'ERPSoapEndpointSettings': 2, 'InterfaceRecurringJobs': 3, 'MailTemplates': 4, 'ShopfloorAppSettings': 5 }

// SystemMessageIds
export const systemMessageIds = { 'UnknownQualityCheck': 8, 'QualityOutOfSpec': 9 }
// timeout names
export const timeouts = { 'LOGOUTTIMEOUT': "logoutTimeout", 'SESSIONTIMEOUTPOPUP': "sessionTimeoutPopup" }

//languages
export const languageIds = { 'ENGLISH': 3, 'DUTCH': 1 }

// quality sample resuls
export const qualitySampleResults = { 'OK': "OK", 'ERROR': "Error", "WARNING": "Warning" }

// Departments
export const departments = { 'PRODUCTION': 1, 'CARPENTRY': 2, 'RECYCLING': 3 }

// Application
export const applicationIds = { 'SMARTPRODUCTION': 1, 'SMARTPRODUCTIVITY': 2, 'SMARTPRODUCTION/SMARTPRODUCTIVITY': 3 }

// roles
export const roles = { 'ADMINISTRATOR': 1, 'OPERATOR': 2, 'PLOEGCHEF': 3, 'QA': 4, 'EXTRUSIEOPERATOR': 5, 'SCHRIJNWERKERIJOPERATOR': 6, 'SCRAPOPERATOR': 7, "MASTEROPERATOR": 8 }

export const zoneDivisionsParameters = { 'TEMPERATURE': 1, 'LENGTH': 2, 'WIDTH': 3, 'WEIGHT': 4 }


// StandStillTypes
export const StandStillTypes = { 'TECHNICAL': 1, 'PLANNED': 2, 'CLEANSTART': 3, 'CLEANSTOP': 4 }

// StandStillCheckBoxes
export const StandStillCheckBoxes = { 'CHECKED': 1, 'nieuwefilter': 2, 'CLEANSTART': 3, 'CLEANSTOP': 4 }


// ProductieStateLogStates
export const ProductionStateLogStates = { 'START': 1, 'STOP': 2, 'FINISH': 3, 'BOOK': 4, 'STANDSTILL': 5, 'SCRAP': 6, 'GENERAL': 7, 'SHIFTEND': 8 }

// Tables
export const recyclingHistoryTableColumns = { 'ID': 0, 'DATE': 1, 'BARCODE': 2, 'OPERATOR': 3, 'BOOKINGTYPE': 4, 'CARRIERTYPE': 5, 'MATERIALTYPE': 6, 'MATERIALCOLOR': 7, 'NETWEIGHT': 8, 'WORKSTATION': 9, 'WASTELOCATION': 10 };

// BookingTypes
export const bookingTypes = { 'REGISTER': 1, 'WRITE_OFF': 2 }

// Default RecyclingStations
export const defaultRecyclingStations = { 'RECYCLAGE_1': 190 }



